import { useState, useEffect } from "react";

import { api } from "../../services/axios";

export const useGetPartnerBU = () => {
  const [loadingGetBU, setLoadingGetBU] = useState(true);
  const [partnerBU, setPartnerBU] = useState(null);
  const [errorPartnerBU, setErrorPartnerBU] = useState(null);

  const document = localStorage.getItem("username");

  useEffect(() => {
    const fetchPartnerBU = async () => {
      try {
        setLoadingGetBU(true);
        setErrorPartnerBU(null);
        const { data } = await api.get("/portalCliente/parceiroBU", {
          params: {
            document,
          },
        });
        setPartnerBU(data);
      } catch (err) {
        console.error("Error fetching Partner BU:", err);
        setErrorPartnerBU(err);
      } finally {
        setLoadingGetBU(false);
      }
    };
    fetchPartnerBU();
  }, [document]);

  return { loadingGetBU, partnerBU, errorPartnerBU };
};
